import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getDetailsTable } from "../../../Requests/deltaHedgeAccounts";
import { IDeltaHedgeAccountDetailReportSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import { Additional } from "../Aggregate/Additional/Additional";

interface IProps {
  searchParams: IDeltaHedgeAccountDetailReportSearchParam;
}

const DetailsTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getDetailsTable}
      searchParameters={searchParams}
      refreshTableTime={10000}
    />
  );
};

export default DetailsTable;
